import {HttpEventType, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {finalize, tap} from 'rxjs/operators';

import {LoadingService} from '@shared/services/loading.service';

export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);
  return next(req).pipe(
    tap((event) => {
      if (event.type === HttpEventType.Sent && !req.url.endsWith('.svg')) {
        loadingService.setButtonLoading(true);
      }
      if (event.type === HttpEventType.Response) {
        loadingService.setButtonLoading(false);
      }
    }),
    finalize(() => {
      loadingService.setButtonLoading(false);
    }),
  );
};
